import React from 'react';
import NoImageSVG from 'serp-files/images/no-image.svg';
import productStyles from '~/components/organisms/products/productSingleResult/productImage.module.scss';
import { useProductContext } from '~/components/organisms/products/productSingleResult/productResultContext';
import ProductResultImageLabels from '~/components/organisms/products/productSingleResult/ProductResultImageLabels';
import Variants from '~/plugins/packages/ivarcs/components/variants/variants';

// TODO napojit název produktu na image alt

const ProductResultImage: React.FC = () => {
    const { result, customColorsConfiguration } = useProductContext();
    const labelsConfiguration = customColorsConfiguration.labels;
    return (
        <div className={productStyles.serpProductImage}>
            {<img src={result.image ? result.image : NoImageSVG} alt="Náhled produktu" />}
            <ProductResultImageLabels items={result.labels} configuration={labelsConfiguration} />
            <Variants items={result.variantTypes} limit={4} />
        </div>
    );
};

export default ProductResultImage;
